// extracted by mini-css-extract-plugin
export default {"wrapper":"MaterialConfigEmpty_wrapper__-xNn6","uploadFile":"MaterialConfigEmpty_uploadFile__23y4P","separator":"MaterialConfigEmpty_separator__0UjJn"};